import { useState, useEffect } from 'react'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { logApiError } from 'services/apiError'
import AttachmentList from 'components/Lists/AttachmentList'
import { ReactComponent as Loading } from 'icons/loading2.svg'
import { Container } from '../styles'

export default function CustomerAttachments ({ customer }) {
  const [loading, setLoading] = useState (true)
  const [attachments, setAttachments] = useState ([])
  const businessId = AuthService.getBusinessId ()
  const token = AuthService.getToken ()

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  useEffect (() => {
    getAttachments ()
  }, [customer])

  const getAttachments = async () => {
    try {
      const { data: attachments } = await cutileiApi.get (
        `/businesses/${businessId}/attachments?customer_id=${customer.id}`,
        requestConfig
      )
      setAttachments (attachments)
    } catch (error) {
      logApiError (error)
    } finally {
      setLoading (false)
    }
  }

  return (
    <Container style={{paddingInline: 10}}>
      {loading ? <Loading style={{marginBottom: 20}}/> : (
        <AttachmentList
          attachments={attachments}
          customerID={customer.id}
          onAttachmentAdded={attachment => setAttachments ([attachment, ...attachments])}
          onDelete={attachment => setAttachments (attachments.filter (a => a.id !== attachment.id))}
        />
      )}
    </Container>
  )
}
